import { useNavigate, useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import { Loader } from '@shared';
import { RouteEnum } from 'App';
import { Form } from '../Form';
import { useUpdateCourse } from './useUpdateCourse';

export const Edit = ({ rootPath, partnerId }: { rootPath: RouteEnum; partnerId: string }) => {
  const { id: courseId } = useParams() as Record<string, string>;
  const { data, isLoading, updateCourse, isUpdating } = useUpdateCourse({
    partnerId,
    courseId,
    rootPath,
  });
  const navigate = useNavigate();
  const onExit = () => navigate(rootPath);
  if (data) {
    return (
      <Container component='article' maxWidth='sm'>
        <Form
          onSubmit={updateCourse}
          initialValues={data}
          isLoading={isUpdating || isLoading}
          onExit={onExit}
          title='Update course'
          submitButtonLabel='Save'
        />
      </Container>
    );
  }
  return <Loader />;
};
